module.exports = __webpack_public_path__ + "static/media/sieva-logo.070a65d8.png";